import { useSelector } from 'react-redux';
import { contributorsSelector } from 'state/selectors/contributors';
import { teamsFlatTreeSelector } from 'state/selectors/teams';
import { getTreeTeamsContributors } from 'common/utils/contributors.utils';

const useTreeTeamsContributors = ({ teams = [] }) => {
  const contributors = useSelector(contributorsSelector);
  const teamsTree = useSelector(teamsFlatTreeSelector) || [];

  const teamsWithChildren = teamsTree.filter(team =>
    teams.map(({ id }) => id).includes(team.id)
  );

  const teamsContributors = getTreeTeamsContributors({
    teams: teamsWithChildren,
    contributors
  });

  return teamsContributors;
};

export default useTreeTeamsContributors;
